import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'

import router from './router'
import {store} from "./store"
import i18n from './i18n'
import lodash from 'lodash'
import VueSession from 'vue-session'
import VueCookies from 'vue-cookies'
import VueJWT from 'vuejs-jwt'

Vue.config.productionTip = false

Vue.prototype.lodash = lodash;

// localStorage에서 저장된 언어 설정 적용 (없으면 기본 kor)
function initLocale() {
  const storedLang = localStorage.getItem('lang_cd');
  const lang = storedLang === 'eng' ? 'eng' : 'kor';
  store.commit('setLangCd', lang);
  i18n.locale = lang;
}
initLocale();

//Vue.prototype.$rootUrl = "https://lims.hlscience.com"
Vue.prototype.$lookupUrl = (process.env.NODE_ENV==='development')?"/lookup/proxy":""

var sessionOption = {
  persist: false
}
Vue.use(VueJWT)
Vue.use(VueSession, sessionOption)
Vue.use(VueCookies);

VueCookies.config('1y');

new Vue({
  vuetify,
  router,
  store: store,
  i18n,
  render: h => h(App)
}).$mount('#app')
